const getContract = ({ contract: { document } }, type) => document[type];

const getWorkspaceContracts = ({ contract: { workspace } }, type) => workspace[type];

export default {
  getContract,
  getWorkspaceContracts,
};
